import React from 'react'
import styled, { css } from 'styled-components'
import th from 'utils/themeHelper'
import { AccountCircle } from '@styled-icons/material'

export const Divider = styled.div`
  border-top: solid 2px #f3f3f3;
  width: 100%;
`

export const ProfileDropdown = styled.button`
  border: none;
  border-radius: 18px;
  display: flex;
  background-color: white;
  color: ${th('text.dark')};
  cursor: pointer;
  flex-flow: row nowrap;
  font-family: ${th('fonts.bold')};
  font-size: 18px;
  height: 35px;
  justify-content: space-between;
  padding-left: 10px;
  vertical-align: middle;
  width: 90px;
`

const UserAvatar = styled.div`
  background-image: url(${({ src }) => src});
  background-size: cover;
  background-position: center center;
  border-radius: 50%;
  height: 30px;
  margin-top: 1.5px;
  width: 30px;
`

export const ProfilePicture = ({ user }) => {
  if (user.avatar_url) {
    return <UserAvatar src={user.avatar_url} />
  }

  return <AccountCircle height="33" />
}

export const ProfileDropdownOptions = styled.div`
  align-content: space-around;
  background-color: white;
  display: flex;
  border: 1px solid ${th('borders.default')};
  border-radius: 8px;
  box-shadow: 3px 3px 10px;
  flex-flow: column nowrap;
  left: -160px;
  margin-top: 8px;
  min-width: 250px;
  position: absolute;
  z-index: 9999;
`

export const DropdownItem = styled.a`
  color: ${th('text.dark')};
  border-radius: ${props =>
    props.firstItem ? '8px 8px 0 0' : props.lastItem ? '0 0 8px 8px' : '0'};
  padding: ${props =>
    props.firstItem
      ? '20px 0 20px 30px'
      : props.lastItem
      ? '20px 0 20px 30px'
      : '15px 0 15px 30px'};

  &:hover {
    background: ${th('backgrounds.light')};
  }
`

export const NotificationIcon = styled.span`
  background: #ed1c24;
  border-radius: 50%;
  color: white;
  padding: 3px;
  position: absolute;
  right: 4px;
  top: 4px;

  ${({ menuItem }) => {
    if (menuItem) {
      return css`
        right: auto;
        left: auto;
        top: 0;
      `
    }
  }}
`

export const ProfileWrapper = styled.div`
  position: relative;

  a {
    cursor: pointer;
  }
`

export const ProfileMenuWrapper = styled.div``
